module.exports = __webpack_public_path__ + "img/country-insights-macro.47369ec1.jpg";